import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 28, className = "", as = "div" }) => {
  const M = motion[as] || motion.div;
  return (
    <M
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.15 }}
      transition={{ duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] }}
      className={className}
    >
      {children}
    </M>
  );
};

export const SectionHead = ({ eyebrow, title, sub, align = "left" }) => (
  <div className={`mb-14 ${align === "center" ? "text-center" : ""}`}>
    {eyebrow && <Reveal><p className="eyebrow mb-4">{eyebrow}</p></Reveal>}
    <Reveal delay={0.05}>
      <h2 className="font-display text-3xl font-extrabold uppercase tracking-tight text-pearl sm:text-4xl lg:text-5xl">
        {title}
      </h2>
    </Reveal>
    {sub && (
      <Reveal delay={0.1}>
        <p className="mt-5 max-w-2xl text-base leading-relaxed text-stonemute">{sub}</p>
      </Reveal>
    )}
  </div>
);

export default Reveal;
